import type Item from 'owa-service/lib/contract/Item';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { addToMeetingItemFetchList } from './meetingItemFetchListOperations';
import { shouldShowRSVPBasedOnInitialCheck } from './shouldShowRSVPBasedOnInitialCheck';

/**
 * Prepares meeting data for the item
 * @returns whether to show RSVP for the item
 * @param serviceItem Item payload for the item to be added or updated
 * @param tableView The table view
 */
export const prepareMeetingDataForItemAndGetShouldShowRSVP = (
    serviceItem: Item,
    tableView: TableView
) => {
    const itemId = serviceItem.ItemId.Id;
    const itemClass = serviceItem.ItemClass;
    if (!shouldShowRSVPBasedOnInitialCheck(itemId, itemClass, tableView)) {
        return false;
    }
    addToMeetingItemFetchList(itemId, tableView.id);
    return true;
};
